<template>
    <div>
        <div class="flex flex-col">
            <div id="title-general" class="flex justify-between items-center">
                <div class="flex justify-between items-center">
                    <router-link
                        to="/app/inventories"
                        class="rounded-full bg-brand-blue flex justify-center items-center p-2"
                    >
                        <span>🏠</span>
                    </router-link>
                    <h1 class="text-3xl">
                        &nbsp;Detalle de Entrada de inventario #{{ id }}
                    </h1>
                </div>
                <custom-switch
                    v-if="$ability.hasPermission('inventory:Update') && id"
                    v-model="enabledUpdate"
                >
                    <span class="text-theme-inverse">🖊</span>
                </custom-switch>
            </div>
        </div>
        <div v-if="id" id="inventory-features">
            <div class="flex mt-3 mb-5">
                <div class="w-full flex justify-between mb-3">
                    <div class="flex flex-col">
                        <router-link
                            :to="`/app/inventories/${itemComponent.merchantType}/${itemComponent.merchantId}/detail/${itemComponent.referenceId}`"
                            class="btn-a p-0"
                        >
                            <span class="h4 text-center">
                                {{ itemComponent.name }}
                            </span>
                        </router-link>

                        <span>
                            Prod
                            <router-link
                                :to="`/app/products/detail/${itemComponent.productId}`"
                                class="btn-a p-0"
                            >
                                {{
                                    itemComponent.product.sku
                                        ? `SKU ${itemComponent.product.sku}`
                                        : `ID ${itemComponent.productId}`
                                }}
                            </router-link>
                            | Ref
                            <router-link
                                :to="`/app/products/detail/${itemComponent.productId}?reference=${itemComponent.referenceId}&tab=references`"
                                class="btn-a p-0"
                            >
                                {{
                                    itemComponent.barcode
                                        ? `Cód. ${itemComponent.barcode}`
                                        : `ID ${itemComponent.id}`
                                }}
                            </router-link>
                        </span>
                    </div>
                    <div class="flex flex-col">
                        <span>
                            Código de barras :
                            {{ itemComponent.barcode }}
                        </span>
                        <span>
                            SKU :
                            {{ itemComponent.sku }}
                        </span>
                    </div>
                </div>
                <div v-show="costTemp" class="w-1/2 md:w-4/12 flex flex-col">
                    <span class="text-theme-primary">
                        {{ messageCost }}
                    </span>
                    <span>{{ messageValue }}</span>
                </div>
                <div v-show="costTemp" class="w-1/2 md:w-4/12 flex flex-col">
                    <span class="text-theme-primary"> Precio u. actual </span>
                    <span> {{ itemComponent.priceOffer | money }}</span>
                </div>
                <div v-show="costTemp" class="w-1/2 md:w-4/12 flex flex-col">
                    <span class="text-theme-primary"> Margen bruto </span>
                    <span>{{ revenue | percent }}</span>
                </div>
                <div class="w-1/2 md:w-4/12 flex flex-col">
                    <span class="text-theme-primary">
                        {{ itemComponent.merchantType | merchantInfo("type") }}
                    </span>
                    <span>{{ itemComponent.merchantName }}</span>
                </div>
                <div class="w-1/2 md:w-4/12 flex flex-col">
                    <span class="text-theme-primary">
                        Color | Tamaño/Talla/Valor
                    </span>
                    <span>
                        {{ itemComponent.color }} | {{ itemComponent.size }}
                    </span>
                </div>
                <div class="w-1/2 md:w-4/12 flex flex-col">
                    <span class="text-theme-primary"> Fecha de registro </span>
                    <span class="text-left">
                        📆💾 {{ itemComponent.createdAt | date }}
                    </span>
                </div>
            </div>

            <div class="w-full mt-3">
                <custom-input
                    v-model="itemComponent.quantity"
                    type="number"
                    min="1"
                    label="Cantidad"
                    disabled
                />
            </div>

            <div class="w-full mt-5 flex items-end">
                <div class="w-full">
                    <input-money-component
                        v-model="costTemp"
                        :enabled="enabledUpdate"
                        :label="
                            isInputCostUnit
                                ? 'Costo de unidad'
                                : 'Costo de lote'
                        "
                        :disabled="!enabledUpdate"
                        class="min-w-full"
                        @blur="calculateUnitCost"
                    />
                    <p
                        v-if="costWarning"
                        class="mt-1 text-xs text-theme-warning"
                    >
                        {{ costWarning }}
                    </p>
                </div>
                <custom-tooltip>
                    <app-button
                        icon
                        border
                        :active="isInputCostUnit"
                        @click="updateUnitCostSw"
                    >
                        {{ isInputCostUnit ? "1️⃣" : "🔢" }}
                    </app-button>
                    <template #tooltip>
                        <div class="content-tooltip">
                            <span v-if="isInputCostUnit">
                                Registrar con costo de lote
                            </span>
                            <span v-else>Registrar con costo de unidad</span>
                        </div>
                    </template>
                </custom-tooltip>
            </div>

            <div class="flex h-10 mt-3">
                <div v-if="enabledUpdate" class="w-full flex justify-center">
                    <app-button
                        @click="updateInputsInventoryByMerchantComponent"
                    >
                        Actualizar entrada de inventario
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import { getCostWarning } from "@/common/lib/price-offer";

import CustomInput from "@/components/utils/CustomInput.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "InventoryInputDetail",
    components: { InputMoneyComponent, CustomInput },
    data: () => ({
        enabledUpdate: false,
        isLoading: false,
        itemComponent: {
            productId: 1,
            referenceId: 1,
            name: "Nombre de producto",
            size: "",
            color: "",
            id: 0,
            createdAt: "",
            costNew: 0,
            quantity: 1,
            merchantId: "",
            merchantType: "store",
            merchantName: "",
            priceOffer: 0
        },
        costTemp: 0,
        id: null,
        revenue: 0,
        isInputCostUnit: true,
        messageCost: "Costo de lote",
        messageValue: 0
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor", "stateInputDark"]),
        costWarning() {
            return getCostWarning({
                salePrice: this.itemComponent.priceOffer,
                cost: this.itemComponent.costNew,
                offerActive: false
            });
        },
        stateEnabled() {
            return this.enabledUpdate ? this.stateInputDark : "";
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("inventory:Get", "/app/inventories")))
            return;
        this.id = parseInt(this.$route.params.id);
        this.getBaseInputInventory({
            id: this.id,
            merchantId: this.$route.query.merchantId,
            merchantType: this.$route.query.merchantType
        });
    },
    methods: {
        ...mapActions("inventories", [
            "getInputInventoryById",
            "updateInputsInventoryByMerchant"
        ]),
        async getBaseInputInventory({ id, merchantId, merchantType }) {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.itemComponent = await this.getInputInventoryById({
                    id,
                    merchantId,
                    merchantType
                });
                this.isInputCostUnit = true;
                this.costTemp = +this.itemComponent.costNew;
                this.isInputCostUnit = true;
                this.calculateUnitCost();
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push("/app/inventories");
                }
            }
        },
        async updateInputsInventoryByMerchantComponent() {
            this.isLoading = true;
            this.$loading.show();
            try {
                await this.updateInputsInventoryByMerchant(this.itemComponent);
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        updateUnitCostSw() {
            if (this.isInputCostUnit) {
                this.costTemp = this.costTemp * this.itemComponent.quantity;
            } else {
                this.costTemp = this.costTemp / this.itemComponent.quantity;
            }
            this.isInputCostUnit = !this.isInputCostUnit;
            this.calculateUnitCost();
        },
        calculateUnitCost() {
            let costUnit = 0;
            if (this.isInputCostUnit) {
                costUnit = +this.costTemp;
                this.itemComponent.costNew = parseInt(this.costTemp);
                this.messageCost = "Costo de lote";
                this.messageValue = this.$options.filters.money(
                    costUnit * this.itemComponent.quantity
                );
            } else {
                costUnit = this.costTemp / this.itemComponent.quantity;
                this.itemComponent.costNew = +costUnit;
                this.messageCost = `Costo de unidad`;
                this.messageValue = this.$options.filters.money(
                    costUnit.toFixed(2)
                );
            }
            this.revenue = 1 - costUnit / this.itemComponent.priceOffer;
        }
    }
};
</script>
